export default __webpack_public_path__ + "static/media/benefit2.e896fce3.svg";